import { styled } from '@mui/material';

import Tooltip, { tooltipClasses } from '../../../../../components/Tooltip';
import { generateClasses } from '../../../../../utils/helper';
import { WidgetWrapperRadioOption } from '../../../../shared/styles';
import PollWidget from '../../../PollWidget';

export const pollListClasses = generateClasses('PollList', ['pollCard', 'selectedPoll']);

export const RadioOption = styled(WidgetWrapperRadioOption)(() => ({
  [`& .${pollListClasses.pollCard}`]: {
    // flex property should work here because RadioOption is a flex container
    flex: 1,
  },
}));

export const PollCard = styled(PollWidget)(({ theme }) => ({
  '&:hover': {
    borderColor: theme.palette.primary[500],
  },
  [`&.${pollListClasses.selectedPoll}`]: {
    borderColor: 'transparent',
    outline: `2px solid ${theme.palette.primary[500]}`,
    outlineOffset: -2,
  },
}));

export const PollDetailsPopper = styled(Tooltip)(({ theme }) => ({
  filter: 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.5))',
  [`& .${tooltipClasses.tooltip}`]: {
    ...theme.typography.paragraphMedium,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    padding: 0,
    border: `0.5px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(2),
    minWidth: 360,
    maxWidth: 456,
    minHeight: 48,
    maxHeight: 400,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
}));
